import React from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box, Typography } from '@mui/material';
import { formatDate } from '../../../../utils/formatDate';
import { useSelector } from 'react-redux';

export const HistoryTableBody = ({ data, isPromotion }) => {

  const { cities, cms, partnersList } = useSelector((state) => state.partners);
  const { triggers } = useSelector((state) => state.logging)

  const findCityName = (id) => cities?.filter(city => city.id === id)[0]?.name;

  const findPackage = (id) => cms?.filter(item => item.id === id)[0]?.name;

  const findPartner = (id) => partnersList?.filter(item => item.id === id)[0]?.name;

  const parseMessage = (message, trigger_id) => {
    if (message) {
      if (message.status && (message.status === 'Действующий' || message.status === 'Архив' || message.status === 'Активна'))
        return [`Изменяет статус ${isPromotion ? 'акции' : 'партнёра'} на ${message.status}`];
      else {
        const trigger = triggers.filter(trigger => trigger.id === trigger_id)[0]?.slug;
        const isCreated = trigger === 'post_partners_promotions' || trigger === 'post_partners';
        const fields = [];
        const values = [];
        const resultMessage = [];

        Object.keys(message).forEach(key => {
          switch (key) {
            case 'cms_package_id':
              fields.push('Название');
              values.push(findPackage(message[key]));
              break;
            case 'partner_id':
              fields.push('Название партнёра');
              values.push(findPartner(message[key]));
              break;
            case 'name':
              fields.push('Название');
              values.push(message[key]);
              break;
            case 'email':
              fields.push('Email');
              values.push(message[key]);
              break;
            case 'bin_number':
              fields.push('БИН');
              values.push(message[key]);
              break;
            case 'contact_person':
              if (message[key]) {
                fields.push('Контактное лицо');
                values.push(message[key]);
              }
              break;
            case 'cities_id':
            case 'city_ids':
              if (message[key].length) {
                fields.push('Города');
                // eslint-disable-next-line no-case-declarations
                let cityValue = '';
                message[key].forEach((city, index, array) => {
                  cityValue += findCityName(city);
                  if (index !== array.length - 1) cityValue += ', ';
                })
                values.push(cityValue);
              }
              break;
            case 'phones':
              if (message[key].length) {
                fields.push('Номера телефонов');
                // eslint-disable-next-line no-case-declarations
                let phoneValue = '';
                message[key].forEach(phone => phoneValue += `+${phone}`)
                values.push(phoneValue);
              }
              break;
            case 'date_start':
              fields.push('Дата старта');
              values.push(formatDate(message[key]));
              break;
            case 'date_end':
              fields.push('Дата окончания');
              values.push(formatDate(message[key], true));
              break;
            case 'promo_code_amount':
              if (message[key]) {
                fields.push('Количество промокодов');
                values.push(message[key]);
              }
              break;
            case 'discount':
              if (message[key]) {
                fields.push('Сумма предлагаемой скидки');
                values.push(message[key]);
              }
              break;
            case 'site_url':
              if (message[key]) {
                fields.push('Web страница для получения услуги из МП');
                values.push(message[key]);
              }
              break;
            case 'show_all':
                fields.push('Отображать для');
                values.push(message[key] ? 'Всем' : 'По списку');
              break;
            case 'generate_promo_code':
              fields.push('Промокоды');
              values.push(message[key] ? 'Сформировать промокоды автоматически' : 'Загрузить список');
              break;
            case 'customer_file_names':
              fields.push('Загружает файлы по абонентам');
              // eslint-disable-next-line no-case-declarations
              let filesNames = '';
              message[key].forEach((file, index, array) => {
                filesNames = `"${file}"`;
                if (index !== array.length - 1) filesNames += ', ';
              });
              values.push(filesNames);
              break;
            case 'promo_code_file_names':
              fields.push('Загружает файлы по промокодам');
              // eslint-disable-next-line no-case-declarations
              let fileNames = '';
              message[key].forEach((file, index, array) => {
                fileNames = `"${file}"`;
                if (index !== array.length - 1) fileNames += ', ';
              });
              values.push(fileNames);
              break;
          }
        });

        if (!fields.length && resultMessage.length) return resultMessage;
        else if (fields.length === 1 && !fields[0].includes('Загружает')) return [`Изменяет поле ${fields[0]} на ${values[0]}`];
        else if (fields.length === 1 && fields[0].includes('Загружает')) return [`${fields[0]} ${values[0]}`];
        else if (fields.length === 2 && fields[0].includes('Загружает') && fields[1].includes('Загружает'))
          return [`${fields[0]} ${values[0]}`, `${fields[1]} ${values[1]}`];
        else {
          resultMessage.push(isCreated ? `Создает ${isPromotion ? 'акцию' : 'партнёра'} с полями:` : 'Изменяет поля');
          fields.forEach((field, index) => resultMessage.push(isCreated ? `${field}: ${values[index]}` : `${field} на ${values[index]}`));
          return resultMessage;
        }
      }
    }
  }

  return (
    <TableBody>
      {data?.map((item) => {
        const parsedMessage = parseMessage(item?.message?.payload, item?.trigger_id);
        return parsedMessage?.length && (
          <TableRow
            key={`history${item.id}`}
          >
            <TableCell>
              <Box width="130px">{formatDate(item.created_at, true)}</Box>
            </TableCell>

            <TableCell>
              <Box width="90px">{formatDate(item.created_at, false, true)}</Box>
            </TableCell>

            <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
              <Box sx={{ fontWeight: 500 }}
                   minWidth="235px">{item?.message?.author?.fullname === 'System' ? 'Система' : item?.message?.author?.fullname}</Box>
            </TableCell>

            <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
              <Box maxWidth="500px"
                   minWidth="350px">{parsedMessage?.map(item => <Typography
                key={item}>{item}</Typography>)}</Box>
            </TableCell>
          </TableRow>
        )
      })}
    </TableBody>
  );
};

HistoryTableBody.propTypes = {
  data: PropTypes.array,
  isPromotion: PropTypes.bool
};
